import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosOrganizationInstance from "./AxiosOrganizationInstance";
// import FeaturesManager from "../components/FeaturesManager";
import HtmlEditor from "../components/HtmlEditor";
import "./css/create-school.css"; // Ensure this path is correct

const Createorganization = () => {
  let userId = localStorage.getItem("userId");
  userId = JSON.parse(userId);
  // alert("userId "+ user.userId)
  const [isTouched, setIsTouched] = useState(false);
  const [organizationCode, setorganizationCode] = useState("");
  const [organizationName, setorganizationName] = useState("");
  const [organizationType, setorganizationType] = useState("School");
  const [phoneNumber, setphoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [notes, setNotes] = useState("");
  const [status] = useState("ACTIVE"); // Default to INACTIVE and hide
  const [website, setWebsite] = useState("");
  const [isAdmissions, setIsAdmissions] = useState(false);
  const [specializations, setSpecializations] = useState("");
  const [features, setFeatures] = useState("");
  const [offers, setOffers] = useState("");
  const [createdById, setCreatedById] = useState("");
  const [organizationPhoto, setorganizationPhoto] = useState(null); // For the organization photo

  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");  
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [lat, setlat] = useState("");
  const [lon, setlon] = useState("");
  const [addressSuggestions, setAddressSuggestions] = useState([]);
  const [addressSearch, setAddressSearch] = useState("");
  const navigate = useNavigate();
  const getAuthHeaders = () => {
    const token = localStorage.getItem("Token");
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  // Handle Address Search
  const handleAddressSearch = async (e) => {
    setAddressSearch(e.target.value);
    if (e.target.value.length > 2) {
      try {
        const response = await axiosOrganizationInstance.get("/address/suggest", {
          headers: getAuthHeaders(),
          params: {
            address: e.target.value,
          },
        });
        setAddressSuggestions(response.data.suggestions || []);
      } catch (error) {
        console.error(
          "Error fetching address suggestions:",
          error.response ? error.response.data : error.message
        );
      }
    } else {
      setAddressSuggestions([]);
    }
  };

  // Handle Address Selection
  const handleAddressSelect = async (placeId) => {
    try {
      const response = await axiosOrganizationInstance.get(
        "/address/suggest/details",
        {
          headers: getAuthHeaders(),
          params: { placeId },
        }
      );

      const placeDetails = response.data;
      console.log("Data", placeDetails);
      if (!placeDetails) {
        alert("Address details not found");
        return;
      }
      const fullAddress = `${placeDetails.addressLine1 || ""}, ${
        placeDetails.addressLine2 || ""
      }, ${placeDetails.city || ""}, ${placeDetails.state || ""}, ${
        placeDetails.country || ""
      }, ${placeDetails.postalCode || ""}`;
      console.log("ADD", fullAddress);
      setAddressSearch(fullAddress);
      setAddressSearch(fullAddress);
      setAddressLine1(placeDetails.addressLine1);
      setAddressLine2(placeDetails.addressLine2 || "");
      setPostalCode(placeDetails.postalCode || "");
      setCity(placeDetails.city || "");
      setState(placeDetails.state || "");
      setCountry(placeDetails.country || "");
      const mappedLat = placeDetails.latitude ?? placeDetails.lat ?? "";
      const mappedLon = placeDetails.longitude ?? placeDetails.lon ?? "";
      setlat(mappedLat);
      setlon(mappedLon);
      setAddressSuggestions([]); // Clear suggestions after selection
    } catch (error) {
      console.error(
        "Error fetching place details:",
        error.response ? error.response.data : error.message
      );
    }
  };

  const handleorganizationPhotoChange = (e) => {
    setorganizationPhoto(e.target.files[0]);
  };

  const handleAdmissionChange = (event) => {
    setIsAdmissions(event.target.checked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const phoneDigits = String(phoneNumber || "").replace(/\D/g, "");
    if (phoneDigits.length !== 10) {
      alert("Please enter a valid 10-digit phone number.");
      return;
    }

    const latParsed = lat !== "" && lat != null ? parseFloat(String(lat), 10) : NaN;
    const lonParsed = lon !== "" && lon != null ? parseFloat(String(lon), 10) : NaN;

    // Create the data object
    const data = {
      organizationCode,
      organizationName,
      organizationType,
      phoneNumber: phoneDigits,
      email,
      website,
      notes,
      status,
      isAdmissions,
      specializations,
      features,
      offers,
      createdById: userId,
      address: {
        addressLine1,
        addressLine2,
        city,
        state,
        country,
        postalCode,
        ...(Number.isFinite(latParsed) ? { lat: latParsed } : {}),
        ...(Number.isFinite(lonParsed) ? { lon: lonParsed } : {}),
      },
    };

    // Create FormData
    const organizationData = new FormData();
    organizationData.append("data", JSON.stringify(data)); // Append the data object as JSON string

    // If a organization photo is provided, append it
    if (organizationPhoto) {
      organizationData.append("photo", organizationPhoto); // Make sure to use 'photo' to match the backend
    }

    try {
      const token = localStorage.getItem("Token");
      if (!token) {
        alert("Please login again. Token not found.");
        navigate("/partner/login");
        return;
      }

      const response = await axiosOrganizationInstance.post(
        "/organization/address",
        organizationData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // Important for file uploads
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        // alert('organization added successfully');

        // Update the organizationId in localStorage
        const newOrganizationId = response.data.organizationId;
        localStorage.setItem("organizationId", newOrganizationId);

        // Save features if any were added (convert HTML to JSON format)
        if (features && features.trim()) {
          try {
            // Get token again to ensure it's fresh
            const featuresToken = localStorage.getItem("Token");
            if (!featuresToken) {
              console.error("No token found for saving features");
              alert("Warning: Features could not be saved. Please edit the organization to add features.");
              navigate("/organization/admin");
              return;
            }

            // Convert HTML to JSON array format
            const parser = new DOMParser();
            const doc = parser.parseFromString(features, 'text/html');
            const paragraphs = doc.querySelectorAll('p');
            const featuresArray = [];
            
            paragraphs.forEach(p => {
                const text = p.textContent || p.innerText || '';
                const match = text.match(/^(.+?):\s*(.+)$/);
                if (match) {
                    featuresArray.push({
                        category: match[1].trim(),
                        featureName: match[2].trim()
                    });
                } else if (text.trim()) {
                    // If no category:name format, use as featureName with default category
                    featuresArray.push({
                        category: 'General',
                        featureName: text.trim()
                    });
                }
            });

            // If no structured format found, create a single entry
            if (featuresArray.length === 0 && features.trim()) {
                featuresArray.push({
                    category: 'General',
                    featureName: features.trim().replace(/<[^>]*>/g, '') // Strip HTML tags
                });
            }

            if (featuresArray.length > 0) {
                console.log('Saving features to API:', featuresArray);
                console.log('Token exists:', !!featuresToken);
                console.log('Organization ID:', newOrganizationId);
                
                // Small delay to ensure organization is fully committed
                await new Promise(resolve => setTimeout(resolve, 500));
                
                const featuresResponse = await axiosOrganizationInstance.post(
                    `/organization/${newOrganizationId}/features`,
                    featuresArray,
                    {
                        headers: {
                            Authorization: `Bearer ${featuresToken}`,
                            'Content-Type': 'application/json',
                        },
                    }
                );
                console.log('Features saved successfully:', featuresResponse.data);
            }
          } catch (error) {
            console.error("Error saving features:", error);
            console.error("Error response:", error.response?.data);
            console.error("Error status:", error.response?.status);
            // Show user-friendly message
            if (error.response?.status === 401) {
              alert("Warning: Could not save features due to authentication error. Please edit the organization to add features.");
            } else {
              alert("Warning: Features could not be saved. Please edit the organization to add features.");
            }
            // Don't block navigation if features save fails
          }
        }

        // Redirect to organization dashboard
        navigate("/organization/admin");

        // Reset form fields after successful submission
        setorganizationCode("");
        setorganizationName("");
        setorganizationType("");
        setphoneNumber("");
        setEmail("");
        setNotes("");
        setWebsite("");
        setIsAdmissions(false);
        setCreatedById(userId);
        setorganizationPhoto(null);
        setAddressLine1("");
        setAddressLine2("");
        setCity("");
        setState("");
        setCountry("");
        setPostalCode("");
        setlon("");
        setlat("");
      } else {
        alert("Failed to add organization");
      }
    } catch (error) {
  console.error(
    "Error adding organization:",
    error.response ? error.response.data : error.message
  );

  // Extract proper error message
  const errorMessage = error.response?.data?.message || error.response?.data?.error || "Something went wrong";

  alert(errorMessage); // This will now show "Please fill all required fields"
}
  };

  return (
    <div className="create-organization-container">
      <h4>Create Organization</h4>
      <hr />
      <form
        onSubmit={handleSubmit}
        className="create-organization-form needs-validation was-validated"
        noValidate
      >
        {/* Row 1 start */}

        <div className="row">
          <div className="col-md-4">
            <label htmlFor="organizationname" className="form-label">
              Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              value={organizationName}
              className={`form-control ${
                isTouched && !organizationName ? "is-invalid" : ""
              }`}
              id="organizationname"
              onChange={(e) => setorganizationName(e.target.value)}
              onBlur={() => setIsTouched(true)}
            />
          </div>
          <div className="col-md-4">
            <label htmlFor="organizationshortcode" className="form-label">
              Registration Number <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="organizationshortcode"
              value={organizationCode}
              onChange={(e) => setorganizationCode(e.target.value)}
              required
              // placeholder="Enter organization short code"
            />
          </div>

          {/* <div className="col-md-4">
            <label htmlFor="organizationtype" className="form-label">
              Type <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              value={organizationType}
              className="form-control"
              id="organizationtype"
              onChange={(e) => setorganizationType(e.target.value)}
              required
              // placeholder="Enter organization type"
            />
          </div> */}
          <div className="col-md-4">
            <label className="form-label" htmlFor="notes">
              Specialization
            </label>
            <input
              value={specializations}
              onChange={(e) => setSpecializations(e.target.value)}
              // placeholder="Enter any notes"
              id="notes"
              className="form-control"
            />
          </div>
        </div>
        {/* Row 1 end */}

        {/* Row 2 start */}

        <div className="row">
          <div className="col-md-4">
            <label className="form-label" htmlFor="phoneNumber">
              Phone Number <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              inputMode="numeric"
              maxLength={10}
              value={phoneNumber}
              id="phoneNumber"
              className="form-control"
              onChange={(e) => setphoneNumber(e.target.value.replace(/\D/g, "").slice(0, 10))}
              required
              // placeholder="Enter contact number"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label" htmlFor="organizationemail">
              Email <span className="text-danger">*</span>
            </label>
            <input
              type="email"
              value={email}
              id="organizationemail"
              className="form-control"
              onChange={(e) => setEmail(e.target.value)}
              required
              // placeholder="Enter email"
            />
          </div>

          <div className="col-md-4">
            <label className="form-label" htmlFor="organizationwebsite">
              Website
            </label>
            <input
              type="text"
              value={website}
              id="organizationwebsite"
              className="form-control"
              onChange={(e) => setWebsite(e.target.value)}
              // placeholder="Enter website URL"
            />
          </div>
        </div>
        {/* Row 2 end */}

        <div className="row" id="row3">
          <div className="col-md-6">
            <label className="form-label" htmlFor="notes">
              Notes
            </label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              // placeholder="Enter any notes"
              id="notes"
              className="form-control"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label" htmlFor="photo">
              Photo
            </label>
            <input
              type="file"
              onChange={handleorganizationPhotoChange}
              className="upload-photo-input form-control"
              id="photo"
            />
          </div>
          <div className="col-md-2">
            <span className="form-label">
              Is Admissions Open
            </span>
            <br />
            <input
              type="checkbox"
              checked={isAdmissions}
              onChange={handleAdmissionChange}
              id="isAdmissions"
              className="custom-checkbox"
            />
          </div>
        </div>

        <div className="row" id="row4">
          {/* <div className="col-md-6">
            <label className="form-label" htmlFor="notes">
              Specializations
            </label>
            <textarea
              value={specializations}
              onChange={(e) => setSpecializations(e.target.value)}
              // placeholder="Enter any notes"
              id="notes"
              className="form-control"
            />
          </div> */}
          <div className="col-md-6">
            <label className="form-label" htmlFor="features">
              Features
            </label>
            {/* <FeaturesManager
              organizationId={null}
              disabled={false}
              onFeaturesChange={setFeatures}
            /> */}
             <HtmlEditor
               value={features}
               onChange={setFeatures}
               placeholder={`Please enter features in this format:
Category: Feature Name
(e.g., Infrastructure: Library)`}
               height="200px"
             />
          </div>
          <div className="col-md-6">
            <label className="form-label" htmlFor="notes">
              Offers
            </label>
            <textarea
              value={offers}
              onChange={(e) => setOffers(e.target.value)}
              // placeholder="Enter any notes"
              id="notes"
              className="form-control"
            />
          </div>
        </div>

        {/* Address Section with Autocomplete */}
        <hr />
        <h4>Address</h4>
        {/* address row 1 start */}
        <div className="row">
          <div className="col-md-12">
            <label id="search" className="form-label">
              Search Address
            </label>
            <input
              type="text"
              value={addressSearch}
              onChange={handleAddressSearch}
              onFocus={() => setAddressSearch("")}
              className="form-control"
              id="search"
            />
            {addressSuggestions.length > 0 && (
              <ul className="address-suggestions">
                {addressSuggestions.map((suggestion) => (
                  <li
                    key={suggestion.place_id}
                    onClick={() => handleAddressSelect(suggestion.place_id)}
                  >
                    {suggestion.description}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
        {/* address row 1 end */}
        <div className="row">
          <div className="col-md-6">
            <label className="form-label" htmlFor="addressline1">
              Address Line 1 <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              value={addressLine1}
              id="addressline1"
              onChange={(e) => setAddressLine1(e.target.value)}
              className="form-control"
              required
              //   placeholder="Enter address line 1"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label" htmlFor="addressline2">
              Address Line 2
            </label>
            <input
              type="text"
              value={addressLine2}
              id="addressline2"
              className="form-control"
              onChange={(e) => setAddressLine2(e.target.value)}
              //   placeholder="Enter address line 2"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-4">
            <label className="form-label" htmlFor="city">
              City <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              value={city}
              id="city"
              className="form-control"
              onChange={(e) => setCity(e.target.value)}
              required
              //   placeholder="Enter city"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label" htmlFor="state">
              State <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              value={state}
              id="state"
              className="form-control"
              onChange={(e) => setState(e.target.value)}
              required
              //   placeholder="Enter state"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label" id="postalcode">
              Postal Code <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              value={postalCode}
              id="postalcode"
              className="form-control"
              onChange={(e) => setPostalCode(e.target.value)}
              required
              //   placeholder="Enter postal code"
            />
          </div>
        </div>

        <div className="row" style={{ marginTop: 10 }}>
          <div className="col-md-6">
            <label className="form-label" htmlFor="longitude">
              Longitude
            </label>
            <input
              type="text"
              value={lon}
              id="longitude"
              className="form-control"
              placeholder="Enter longitude"
              readOnly
            />
          </div>
          <div className="col-md-6">
            <label className="form-label" htmlFor="latitude">
              Latitude
            </label>
            <input
              type="text"
              value={lat}
              id="latitude"
              className="form-control"
              placeholder="Enter latitude"
              readOnly
            />
          </div>
        </div>

        <input type="hidden" value={country} />

        <div className="org-create-actions">
          <button type="submit">Create organization</button>
          <button 
            type="button" className="org-cancel-button"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default Createorganization;
